import React from "react";
import styles from "./store-card.module.scss";

import { STORE_TYPE } from "../../../commons/constants/store";
interface props {
  type: STORE_TYPE;
}
const TypeStore: React.FC<props> = ({ type }) => {
  function handleGetStoreStatus(type: STORE_TYPE) {
    switch (type) {
      case STORE_TYPE.ONBOARD:
        return "Onboard";
      case STORE_TYPE.APPROVAL:
        return "Approval";
    }
  }
  return (
    <div className={styles.statusBox}>
      <div className={`${styles.status} ${type === STORE_TYPE.ONBOARD ? styles.active : styles.suspend}`}>
        {handleGetStoreStatus(type)}
      </div>
      {/* {storeId && (
        <div
          onClick={e => {
            e.stopPropagation();
            handleOpenModal();
          }}
          className={styles.dotIconWrapper}
        >
          <img src={dot} alt="dot" className={styles.dotIcon} />
        </div>
      )} */}
    </div>
  );
};

export default TypeStore;
